export default __webpack_public_path__ + "static/media/slide1.a8c5279a.jpg";